import { defineSlotRecipe as e } from "@pandacss/dev";
import { anatomy as o } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/file-upload/dist/index.mjs";
const r = [...o.keys(), "sortableItem", "hiddenInput", "rootProvider"], t = e({
  className: "file-upload",
  slots: r,
  base: {
    dropzone: {
      border: "1px dashed",
      borderColor: "border-primary",
      borderRadius: "4",
      padding: "3",
      gap: "2"
    },
    sortableItem: {
      animation: "fadeIn 0.25s ease-out",
      background: "bg.default",
      borderRadius: "l3",
      borderWidth: "1px",
      display: "grid",
      columnGap: "3",
      gridTemplateColumns: "auto auto 1fr auto",
      gridTemplateAreas: `
          "sort preview name delete"
          "sort preview size delete"
          `,
      p: "4"
    },
    rootProvider: {
      display: "flex",
      flexDirection: "column",
      width: "352px",
      gap: "3"
    }
  }
});
export {
  t as fileUpload
};
